import '../components/modal/modal.js';
import '../components/zoomable-image/zoomable-image.js';
import '../components/zoom-layer/zoom-layer.js';
import '../components/ai-badge/ai-badge.js';
import '../components/product-personalization-banner/product-personalization-banner.js';
import '../components/infobox/infobox.js';

if (
  document.querySelector('ents-online-reservation-link, ents-online-reservation, ents-online-reservation-app-layer')
) {
  import('../components/online-reservation-ssi/online-reservation.js');
  import('../components/online-reservation-ssi/online-reservation-app-layer.js');
  import('../components/online-reservation-link/online-reservation-link.js');
}

if (document.querySelector('ents-vsp-modal')) {
  import('../components/vsp-modal/vsp-modal.js');
}

if (document.querySelector('ents-material-tracking')) {
  import('../components/product-summary/material-tracking.js');
}
